package com.nonopn.skywatcher.common.app.portfolio.selected

import com.nonopn.skywatcher.common.app.api.impl.ApiInterface
import com.nonopn.skywatcher.common.app.pages.sentinels.ThunderDetectionWithMetadata
import com.nonopn.skywatcher.design.appbar.AppBarState
import com.nonopn.skywatcher.design.appbar.AppBarUiState
import com.nonopn.skywatcher.design.appbar.FloatingActionButtonState
import eu.codlab.navigation.RouteParameterTo

private const val Millis = 1000.0

data class ThunderDetectionSelectedModelState(
    var currentRoute: RouteParameterTo,
    val isSystemDarkMode: Boolean,
    override val appBarState: AppBarState = AppBarState.Regular(),
    override val floatingActionButtonState: FloatingActionButtonState? = null,
    val selectedThunderDetection: ThunderDetectionWithMetadata,
    val currentApi: ApiInterface? = null,
) : AppBarUiState
